// extracted by mini-css-extract-plugin
module.exports = {"p20qkp4":"p20qkp4"};